// @flow

import type {
  MultiLevelAction,
  MultiLevelState
} from 'stores/flow-type/filter-tree/multi-level.type';

import {
  INITIAL_MULTI_LEVEL_TAGS,
  UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS,
  INITIAL_MULTI_LEVEL_COLLECTIONS,
  UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS
} from 'stores/flow-type/filter-tree/multi-level.type';

const initialState: MultiLevelState = {
  loading: false,
  success: false,
  error: undefined,
  multiLevelTags: {},
  multiLevelCollections: {}
};

const multiLevelReducers = (state: MultiLevelState = initialState, action: MultiLevelAction) => {
  switch (action.type) {
    case INITIAL_MULTI_LEVEL_TAGS: {
      const { data } = action.payload;
      return {
        ...state,
        multiLevelTags: data
      };
    }

    case UPDATE_MANUAL_VALUES_MULTI_LEVEL_TAGS: {
      let { multiLevelTags } = state;

      // Update manual values
      multiLevelTags.multiLevelTagManualValues = action.payload.data;

      return {
        ...state,
        multiLevelTags
      };
    }

    case INITIAL_MULTI_LEVEL_COLLECTIONS:
      return {
        ...state,
        multiLevelCollections: action.payload.data
      };

    case UPDATE_MANUAL_VALUES_MULTI_LEVEL_COLLECTIONS: {
      let { multiLevelCollections } = state;

      // Update manual values
      multiLevelCollections.collectionMultiLevelManualValues = action.payload.data;

      return {
        ...state,
        multiLevelCollections
      };
    }
    default:
      return state;
  }
};
export default multiLevelReducers;
